export default "__VITE_ASSET__GrhOJVyq__"